var ValueJS = ValueJS || {};

ValueJS.VideoPause = function() {

    var _init = function() {
        $(window).on('blur', function() {
            $('video[autoplay]').each(function() {
                $(this)[0].pause();
            });
        });
        $(window).on('focus', function() {
            $('video[autoplay]').each(function() {
                $(this)[0].play();
            });
        });
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    ValueJS.VideoPause.init();
});